// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p,
h1,
h2,
h3,
h4,
span {
  margin: 0;
  padding: 0;
}

ion-col {
  padding: 0;
}

.wrapper {
  text-align: center;
  padding: 26px 28px 36px;
  color: var(--color-black);
}

.content-wrapper {
  height: 226px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.logo {
  height: 45px;
  width: 156px;
  margin-bottom: 23px;
  --icon-color: black;
}

.title {
  font-family: Title;
  font-size: 40px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.subtitle {
  font-family: AppFont;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  text-wrap: balance;
  margin-bottom: 27px;
}

.button-wrapper {
  width: 90%;
}

ion-spinner {
  color: #fff;
}

.input-wrapper {
  margin: 0 auto;
  margin-bottom: 25px;
  width: 90%;
}

.label {
  position: relative;
  top: 9px;
  left: 17px;
  background: white;
  z-index: 2;
  font-family: SecondaryFontSemiBold;
  font-size: 11px;
  line-height: 20px;
  text-align: left;
  text-transform: capitalize;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

ion-label {
  font-family: AppFont;
  font-size: 11px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
}

ion-item {
  width: 100%;
  text-align: center;
  height: 40px;
  border-bottom: 1px dashed var(--ion-color-primary);
  --background: transparent;
  margin-bottom: 10px;
  margin-top: 0px;
  --padding-start: 0px;
}
ion-item ion-input {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 90%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
}

.cross-btn {
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  height: 16px;
  width: 16px;
  z-index: 1000;
}

.success-icon {
  height: 56px;
  width: 56px;
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/request-email/request-email.component.scss"],"names":[],"mappings":"AAAA;;;;;;EAMC,SAAA;EACA,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAIA;EACC,kBAAA;EACA,uBAAA;EACA,yBAAA;AADD;;AAGA;EACC,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,mBAAA;AADD;;AAIA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,kBAAA;EAEA,mBAAA;AAHD;;AAMA;EACC,UAAA;AAHD;;AA0BA;EACC,WAAA;AAvBD;;AA0BA;EACC,cAAA;EACA,mBAAA;EACA,UAAA;AAvBD;;AA0BA;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,UAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AAvBD;;AA0BA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAvBD;;AA0BA;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AAvBD;;AAyBA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kDAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAtBD;AAuBC;EACC,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AArBF;;AAyBA;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AAtBD;;AAyBA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAtBD","sourcesContent":["p,\nh1,\nh2,\nh3,\nh4,\nspan {\n\tmargin: 0;\n\tpadding: 0;\n}\n\nion-col {\n\tpadding: 0;\n}\n\n$inline-padding: 28px;\n\n.wrapper {\n\ttext-align: center;\n\tpadding: 26px $inline-padding 36px;\n\tcolor: var(--color-black);\n}\n.content-wrapper {\n\theight: 226px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.logo {\n\theight: 45px;\n\twidth: 156px;\n\tmargin-bottom: 23px;\n\t--icon-color: black;\n}\n\n.title {\n\tfont-family: Title;\n\tfont-size: 40px;\n\tline-height: 120%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\n\tmargin-bottom: 10px;\n}\n\n.subtitle {\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tline-height: 100%;\n\tletter-spacing: 0px;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: capitalize;\n\n\ttext-wrap: balance;\n\n\tmargin-bottom: 27px;\n}\n\n.button-wrapper {\n\twidth: 90%;\n}\n\n// .btn {\n// \twidth: 100%;\n// \theight: 54px;\n// \toutline: var(--outline-default);\n// \toutline-offset: var(--outline-offset-default);\n// \tbackground: var(--ion-color-primary);\n// \tborder-radius: var(--radius-default);\n// \tdisplay: flex;\n// \tjustify-content: center;\n// \talign-items: center;\n\n// \tspan {\n// \t\tfont-family: AppFontSemiBold, sans-serif;\n// \t\tcolor: #fff;\n// \t\tfont-size: 16px;\n// \t\tline-height: 19.2px;\n// \t\tletter-spacing: 0.01em;\n// \t}\n// }\n\nion-spinner {\n\tcolor: #fff;\n}\n\n.input-wrapper {\n\tmargin: 0 auto;\n\tmargin-bottom: 25px;\n\twidth: 90%;\n}\n\n.label {\n\tposition: relative;\n\ttop: 9px;\n\tleft: 17px;\n\tbackground: white;\n\tz-index: 2;\n\tfont-family: SecondaryFontSemiBold;\n\tfont-size: 11px;\n\tline-height: 20px;\n\ttext-align: left;\n\ttext-transform: capitalize;\n}\n\n.item {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\nion-label {\n\tfont-family: AppFont;\n\tfont-size: 11px;\n\tline-height: 85%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: capitalize;\n}\nion-item {\n\twidth: 100%;\n\ttext-align: center;\n\theight: 40px;\n\tborder-bottom: 1px dashed var(--ion-color-primary);\n\t--background: transparent;\n\tmargin-bottom: 10px;\n\tmargin-top: 0px;\n\t--padding-start: 0px;\n\tion-input {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 90%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.cross-btn {\n\tcursor: pointer;\n\tposition: absolute;\n\ttop: 20px;\n\tright: 20px;\n\theight: 16px;\n\twidth: 16px;\n\tz-index: 1000;\n}\n\n.success-icon {\n\theight: 56px;\n\twidth: 56px;\n\tmargin-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
